import Chip from '@mui/material/Chip';

export const tutorDetailsTableHeader = [
  {
    field: 'name',
    headerName: 'Name',
    width: 250,
    sortable: true,
  },
  {
    field: 'joinedDate',
    headerName: 'Joined Date',
    width: 180,
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 250,
  },
  {
    field: 'phone',
    headerName: 'Phone',
    width: 180,
  },
  {
    field: 'activeClassCount',
    headerName: 'Active Class',
    width: 180,
    sortable: true,
  },
  {
    field: 'activeStudentCount',
    headerName: 'Active Students',
    width: 180,
    sortable: true,
  },
  {
    field: 'replacementCount',
    headerName: 'Replacement',
    width: 150,
    sortable: true,
  },
  {
    field: 'experience',
    headerName: 'Experience',
    width: 250,
    toolTipGetter: true,
    sortable: true,
  },
  {
    field: 'active',
    headerName: 'Status',
    width: 130,
    renderCell: ({ value }) => (
      <Chip
        label={Boolean(value) ? 'Active' : 'Inactive'}
        variant="filled"
        color={Boolean(value) ? 'success' : 'error'}
      />
    ),
  },
];
export const tutorStatus = [
  { id: -1, name: 'All' },
  { id: 'active', name: 'Active' },
  { id: 'inactive', name: 'Inactive' },
];
